import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { USER_ROLES } from "../utils/constant";
import { useNavigate } from "react-router-dom";
export const Dashboard = () => {
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const navigate = useNavigate();

  // const data = [
  //   {
  //     id: 1,
  //     imageUrl: "/images/coreA.webp",
  //     title: "Cor Advantage",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-A",
  //     link: process.env.REACT_APP_COR_A_URL + "/login",
  //   },
  //   {
  //     id: 2,
  //     imageUrl: "/images/cork.webp",
  //     title: "Cor For Kindergarden",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-K",
  //     link: process.env.REACT_APP_COR_K_URL,
  //   },
  //   {
  //     id: 3,
  //     imageUrl: "/images/classroomCoach.webp",
  //     title: "Classroom Coach",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-C",
  //     link: process.env.REACT_APP_COR_C_URL,
  //   },
  //   {
  //     id: 4,
  //     imageUrl: "/images/letterLink.webp",
  //     title: "Letter Links",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-L",
  //     link: process.env.REACT_APP_LETTER_LINK_URL,
  //   },
  //   {
  //     id: 1,
  //     imageUrl: "/images/logoRSA.webp",
  //     title: "Ready School Assessment",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-R",
  //     link: process.env.REACT_APP_RSA_URL + "/login",
  //   },
  //   {
  //     id: 7,
  //     imageUrl: "/images/logoPQA.webp",
  //     title: "Program Quality Assessment",
  //     discription:
  //       "Reliable, scientifically validated assessment that reflects research-based, field-tested best practices in early childhood education.",
  //     button: "Visit Site",
  //     code: "COR-P",
  //     link: process.env.REACT_APP_COR_P_URL,
  //   },
  //   {
  //     id: 8,
  //     imageUrl: "",
  //     title: "Curriculum",
  //     discription:
  //       "Some quick example text to build on the card title and make up the bulk of the card's content.",
  //     button: "Visit Site",
  //     code: "COR-CU",
  //     link: process.env.REACT_APP_CURR_URL + "/login",
  //   },
  // ];
  const data = [
    {
      id: 1,
      imageUrl: "/images/coreA.webp",
      title: "COR Advantage",
      discription: "Assessing what children know and can do!",
      button: "Visit Site",
      code: "COR-A",
      link: process.env.REACT_APP_COR_A_URL + "/login",
    },
    {
      id: 2,
      imageUrl: "/images/cork.webp",
      title: "COR For Kindergarten",
      discription: "Assessing what children know and can do!",
      button: "Visit Site",
      code: "COR-K",
      link: process.env.REACT_APP_COR_K_URL,
    },
    {
      id: 3,
      imageUrl: "/images/classroomCoach.webp",
      title: "Classroom Coach",
      discription: "Improving Preschool Classroom Quality",
      button: "Visit Site",
      code: "COR-C",
      link: process.env.REACT_APP_COR_C_URL,
    },
    {
      id: 4,
      imageUrl: "/images/logoRSA.webp",
      title: "Ready School Assessment",
      discription: "Improving schools to ensure success for all children!",
      button: "Visit Site",
      code: "COR-R",
      link: process.env.REACT_APP_RSA_URL + "/login",
    },
    {
      id: 5,
      imageUrl: "/images/letterLink.webp",
      title: "Letter Links",
      discription: "Alphabet learning with children’s names!",
      button: "Visit Site",
      code: "COR-L",
      link: process.env.REACT_APP_LETTER_LINK_URL,
    },
    {
      id: 6,
      imageUrl: "/images/logoPQA.webp",
      title: "Program Quality Assessment",
      discription:
        "Reliable, scientifically validated assessment that reflects research-based, field-tested best practices in early childhood education.",
      button: "Visit Site",
      code: "COR-P",
      link: process.env.REACT_APP_COR_P_URL + "/login",
    },
    {
      id: 8,
      imageUrl: "/images/CurriculumNew.png",
      title: "Curriculum",
      discription:
        "Planning for active learning in infant, toddler, and preschool classrooms!",
      button: "Visit Site",
      code: "COR-CU",
      link: process.env.REACT_APP_CURR_URL + "/login",
    },
  ];

  const { instance, inProgress } = useMsal();
  const activeAccount: any = instance.getActiveAccount();
  const [idToken, setIdToken] = useState();
  const [hoveredItem, setHoveredItem] = useState<number>(0);

  useEffect(() => {
    if (activeAccount && !activeAccount.idToken && inProgress === "none") {
      getTokenResponse();
    } else if (
      activeAccount &&
      activeAccount.idToken &&
      inProgress === "none"
    ) {
      setIdToken(activeAccount.idToken);
    }
  }, [activeAccount, inProgress]);

  useEffect(() => {
    if (userDetails && userDetails.role === USER_ROLES.HIGHSCOPE_ADMIN) {
      navigate("/admin_dashboard", { replace: true });
    }
  }, [userDetails]);

  const getTokenResponse = async () => {
    const tokenResponse: any = await instance.acquireTokenSilent({
      account: activeAccount,
      scopes: ["offline_access"],
    });
    setIdToken(tokenResponse.idToken);
  };

  return (
    <>
      {/* <AuthenticatedTemplate>
        {activeAccount && idToken ? ( */}

      <div className="h-screen bg-white p-2 overflow-auto">
        <div className="mb-20 grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-3 gap-3 justify-items-center bg-white p-3 pb-10">
          {userDetails?.userDetails.map((element: any, index: number) => {
            const application: any = data.find(
              (obj) => obj.code === element.application.applicationCode
            );
            if (!application) return null;

            return (
              <div
                key={application.id}
                className="shadow-md w-full max-w-[500px] h-[300px] bg-gray-300 rounded-md overflow-hidden relative flex items-center justify-center cursor-pointer"
                onMouseEnter={() => setHoveredItem(application.id)}
                onMouseLeave={() => setHoveredItem(0)}
                onClick={() => {
                  window.open(application.link + "/?token=" + idToken, "_self");
                }}
              >
                <img
                  src={application.imageUrl}
                  alt={application.title}
                  className="max-w-[60%] max-h-[60%] object-contain rounded-md"
                />
                {hoveredItem === application.id && (
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A80] via-[#1A1A1A40] to-transparent flex flex-col justify-end p-4">
                    <p className="text-white text-sm text-center">
                      {application.discription}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* <Container className="p-3 ">
            <Card className="h-[400px] p-3">
            <Row>
              <Col>
                <Card style={{ width: "18rem", marginBottom: 10 }}>
                  <Card.Img
                    variant="top"
                    src={coreA}
                    style={{
                      height: "10rem",
                      backgroundColor: "#EFFBF8",
                    }}
                    width={"50%"}
                  />
                  <Card.Body>
                    <Card.Title>Core Advantage</Card.Title>
                    <Card.Text>
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => {
                        window.open(
                          "https://coradvantagedev.azurewebsites.net/login/?token=" +
                            idToken,
                          "_self"
                        );
                      }}
                    >
                      Open
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card style={{ width: "18rem" }}>
                  <Card.Img
                    variant="top"
                    src={coreK}
                    style={{
                      height: "10rem",
                      backgroundColor: "#EFFBF8",
                    }}
                  />
                  <Card.Body>
                    <Card.Title>Core For Kindergarden</Card.Title>
                    <Card.Text>
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => {
                        window.open(
                          "https://corforkdev.azurewebsites.net/?token=" +
                            idToken,
                          "_self"
                        );
                      }}
                    >
                      Open
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card style={{ width: "18rem" }}>
                  <Card.Img
                    variant="top"
                    src={classrromColach}
                    style={{
                      height: "10rem",
                      backgroundColor: "#EFFBF8",
                    }}
                  />
                  <Card.Body>
                    <Card.Title>Classroom Coach</Card.Title>
                    <Card.Text>
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => {
                        window.open(
                          "https://classroomcoachdev.azurewebsites.net/?token=" +
                            idToken,
                          "_self"
                        );
                      }}
                    >
                      Open
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card style={{ width: "18rem" }}>
                  <Card.Img
                    variant="top"
                    src={letterLink}
                    style={{
                      height: "10rem",
                      backgroundColor: "#EFFBF8",
                    }}
                  />
                  <Card.Body>
                    <Card.Title>Letter Link</Card.Title>
                    <Card.Text>
                      Some quick example text to build on the card title and
                      make up the bulk of the card's content.
                    </Card.Text>
                    <Button
                      variant="primary"
                      onClick={() => {
                        window.open(
                          "https://letterlinks.azurewebsites.net/login/?token=" +
                            idToken,
                          "_self"
                        );
                      }}
                    >
                      Open
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            </Card>
          </Container> */}
      {/* ) : (
          <div>No Account</div>
        )}
      </AuthenticatedTemplate> */}
    </>
  );
};
